
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehicle_list",
      function () {
        return require("private-next-pages/vehicle_list.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vehicle_list"])
      });
    }
  